import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const EditCard = ({ route, navigation }) => {
    const [name, setName] = useState('');
    const [numberCard, setNumberCard] = useState('');
    const [validity, setValidity] = useState('');
    const { item } = route.params;
    const [isLoading, setIsLoading] = useState(false);
    // const [cvv, setCvv] = useState('');

    useEffect(() => {
        setName(item.name);
        setNumberCard(item.number);
        setValidity(item.validity);
    }, []);

    async function updateCard() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        if (!name) {
            toast("Preencha o nome.", "#DA1414");
            return false;
        }

        if (!numberCard) {
            toast("Preencha o número do cartão.", "#DA1414");
            return false;
        }

        if (!validity) {
            toast("Preencha a validade do cartão.", "#DA1414");
            return false;
        }

        setIsLoading(true);
        const data = {
            "name": name,
            "card_number": numberCard,
            "expiration_date": validity
        }

        api.put(`/cards/${item.id}`, data, { headers: { 'Authorization': `Basic ${token}` } })
            .then(() => {
                navigation.navigate('MyCards');
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error)
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    return (
        <>
            <HeaderDefault title={'Editar cartão'} />

            <View style={styles.container}>
            <InputDefault
                    value={name}
                    onValueChange={(value) => setName(value)}
                    placeholder={"Nome completo"}
                />

                <MaskedInputDefault
                    mask="9999 9999 9999 9999"
                    keyboardType="numeric"
                    value={numberCard}
                    onValueChange={(value) => setNumberCard(value)}
                    placeholder={"Número do cartão"}
                />

                <MaskedInputDefault
                    mask="99/99"
                    keyboardType="numeric"
                    value={validity}
                    onValueChange={(value) => setValidity(value)}
                    placeholder={"Validade"}
                />

                {/* <InputDefault
                    value={cvv}
                    onValueChange={(value) => setCvv(value)}
                    placeholder={"CVV"}
                /> */}
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity disabled={isLoading ? true: false} onPress={updateCard}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#1FBFB5" size="small" />
                        ) : (
                            <Text style={styles.textBtn}>SALVAR</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentBtnDelete}>
                <TouchableOpacity onPress={() => navigation.navigate("DeleteCard", { item })}>
                    <Text style={styles.textBtnDelete}>Excluir cartão</Text>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default EditCard;